import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SupabaseService } from '../services/supabase.service';

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const supabaseService = inject(SupabaseService);
  const router = inject(Router);

  try {
    const session = await supabaseService.getSession();
    
    if (!session?.data?.session?.user) {
      // User is not authenticated, redirect to login with return URL
      const returnUrl = state.url;
      router.navigate(['/login'], { 
        queryParams: { rurl: returnUrl } 
      });
      return false;
    }

    // User is authenticated
    return true;
  } catch (error) {
    // Error checking session, redirect to login
    const returnUrl = state.url;
    router.navigate(['/login'], { 
      queryParams: { rurl: returnUrl } 
    });
    return false;
  }
};

